import React, { FC } from 'react';
import { Header } from '@components/molecules/Header';
import { Footer } from '@components/molecules/Footer';

interface AuthenticationContainerProps {
    children: string | JSX.Element;
}

export const AuthenticationContainer: FC<AuthenticationContainerProps> = ({ children }) => {
    return (
        <div className="page">
            <Header mode="with-separator" />
            <div className="d-flex bg-secondary flex-grow-1 align-items-center py-4 px-3" data-testid="authentication-container">
                {children}
            </div>
            <Footer mode="normal" />
        </div>
    );
};
